import { render, staticRenderFns } from "./ControlPanelRobot.vue?vue&type=template&id=c80aeca8&scoped=true&"
import script from "./ControlPanelRobot.vue?vue&type=script&lang=js&"
export * from "./ControlPanelRobot.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanelRobot.vue?vue&type=style&index=0&id=c80aeca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80aeca8",
  null
  
)

export default component.exports